

































import { Component } from 'vue-property-decorator';
import MixinPage from '@/plugins/podolib/services/helper/mixins/page';
import { TForm } from '@/plugins/podolib/lib/types';
import { ValidationProvider } from 'vee-validate/dist/types/components/Provider';

import AuthCard from '@/components/auth/AuthCard.vue';
import { Severity } from '@sentry/types';

type TFields = {
  email: {
    value: string;
  };
};

@Component({
  components: { AuthCard },
})
export default class PageAuthForgotPassword extends MixinPage {
  $refs!: {
    card: InstanceType<typeof AuthCard> & {
      $refs: {
        observer: InstanceType<typeof ValidationProvider>;
      };
    };
  };

  form: TForm<TFields> = {
    fields: {
      email: {
        value: null!,
      },
    },
    pending: false,
    error: null,
    success: false,
  };

  async sendCodeToResetPassword() {
    // Avoid duplication of the process
    if (this.form.pending) return;
    try {
      // Validate form...
      const isValid = await this.$refs.card.$refs.observer.validate();
      // If form is invalid, stop
      if (!isValid) return;

      // Reset flags
      this.form.success = false;
      this.form.error = null;
      // Set 'pending' flag
      this.form.pending = true;

      // Try to send code ...
      await this.$pdc.cognito!.forgotPassword(this.form.fields.email.value);
      // Analytics
      this.$pdc.analytics?.actions.trackSuccess('User ForgotPassword', {
        email: this.form.fields.email.value,
      });
      // Set 'success' flag
      this.form.success = true;
      // Redirect to home...
      await this.$router.push({ name: 'auth-reset-password', params: { email: this.form.fields.email.value } });
    } catch (e) {
      // Analytics
      this.$pdc.analytics?.actions.trackFailure('User ForgotPassword', e, {
        email: this.form.fields.email.value,
      });
      // Set 'error' flag
      this.form.error = e;
      // Sentry
      this.$sentry.captureMessage(e.message, Severity.Log);
    } finally {
      // Reset 'pending' flag
      this.form.pending = false;
    }
  }
}
